import { useMutation } from "@tanstack/react-query";

import { handleChangePassword } from "@/domain/use-cases/alterar-senha-usuario";
import { notifyError, notifySuccess } from "@/utils/notify-messages";

export function useAlterarSenhaUsuario() {
  const mutation = useMutation<
    any,
    Error,
    {
      token: string;
      senha: string;
      novaSenha: string;
    }
  >({
    mutationFn: async ({ token, senha, novaSenha }) => {
      return await handleChangePassword(token, senha, novaSenha);
    },

    onSuccess: (response: any) => {
      // 1) TRATAR ERRO VINDO DO BACKEND (MESMO COM STATUS 200)
      if (response?.code === 422) {
        const backendMessage = response?.errors?.message || "Erro ao alterar senha.";

        notifyError(backendMessage);
        return;
      }

      // 2) SE NÃO HOUVE ERRO → SUCESSO REAL
      notifySuccess("Senha alterada com sucesso!");
    },

    onError: (err: any) => {
      const msg =
        err?.response?.data?.errors?.message || err?.message || "Erro inesperado ao alterar senha.";

      notifyError(msg);
    },
  });

  return {
    alterarSenha: mutation.mutate,
    alterarSenhaAsync: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    data: mutation.data,
    isSuccess: mutation.isSuccess,
  };
}
